export default "__VITE_ASSET__e68a886b__"